import React from "react";
import Contact from "@/components/overlay/Contact";
import GoogleRecaptcha from "@/components/overlay/GoogleRecaptcha";
import "@/components/overlay/OverlayStyles.scss";


const Overlay = ({
  countryCode,
  isEmailDisplay,
  isPhoneDisplay,
  recaptchaActionName="Default",
  isRecaptchaDisplay=false
}): JSX.Element => {
  return (
    <>
      {isRecaptchaDisplay && <GoogleRecaptcha action={recaptchaActionName} />}
      <Contact
        countryCode={countryCode}
        isEmailDisplay={isEmailDisplay}
        isPhoneDisplay={isPhoneDisplay}
      />
    </>
  );
};

export default Overlay;
